/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Users_Sign_Out_FailedInputs */

const en_users_sign_out_failed = /** @type {(inputs: Users_Sign_Out_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to sign out user: ${i?.message}`)
};

const pt_br2_users_sign_out_failed = /** @type {(inputs: Users_Sign_Out_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao desconectar usuário: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to sign out user: {message}" |
*
* @param {Users_Sign_Out_FailedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_sign_out_failed = /** @type {((inputs: Users_Sign_Out_FailedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Sign_Out_FailedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_sign_out_failed(inputs)
	return pt_br2_users_sign_out_failed(inputs)
});